/** Variante de badge par statut de paiement — partagé table desktop / carte mobile. */
export const statusBadgeVariant = (status: string) => {
  switch ((status || "").toLowerCase()) {
    case "completed":
      return "success";
    case "pending":
      return "outline";
    case "failed":
      return "destructive";
    case "refunded":
      return "secondary";
    default:
      return "outline";
  }
};
